import { Component, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { PartnerService } from '../../services/partner.service';
import { StateService } from '../../../products/services/state.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  private parnerService = inject(PartnerService);
  readonly partner = this.parnerService.state.asReadonly();
  phoneDisplay = computed(() => this.partner().phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1.$2.$3'));
  copyrightYear: number = (new Date()).getFullYear();

  readonly printing = inject(StateService).isPrinting;
}
